import React from 'react';
import { observer } from 'mobx-react';
import { Page, Pane, PaneBody, PaneHeader } from '../../components/atoms/applications/page';
import './withdrawalCancelPage.module.scss';
import moment from 'moment-timezone';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { WithdrawalCancelPageState } from './states/WithdrawalCancelPageState';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { SheModal } from '../../../commonv3/components/molecules/layout/SheModal';
import { V3Routes } from '../../routes';
import { WithdrawalCancelCompletePane } from '../../components/molecules/withdrawals/WithdrawalCancelCompletePane';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { LabelPrimary } from '../../components/atoms/labels/LabelPrimary';
import { WithdrawalDateTime } from '../../components/atoms/withdrawals/WithdrawalDateTime';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import { Button } from '@sheinc/shelikes-design-system';

export const WithdrawalCancelPage = withNavigation(NavigationSpecs.side())(
  observer(
    class WithdrawalCancelPage extends React.Component {
      pageState = new WithdrawalCancelPageState();

      render() {
        const currentUser = GlobalStatesV3.currentUser;
        const withdrawal = GlobalStatesV3.currentUser.withdrawal;
        const effectiveAt = moment(withdrawal.withdrawalEffectiveAt);
        const serviceExpiresAt = moment(effectiveAt).add(-1, 'second');
        const { open, loading, submit } = this.pageState;
        if (loading) {
          return <LoaderRow />;
        }
        if (!withdrawal.isWithdrawalSet) {
          GlobalStatesV3.routing.push(V3Routes.home());
          return null;
        }
        const breadCrumbItems = [{ text: '退会申請キャンセル' }];
        return (
          <Page id={'withdrawal-cancel-page'}>
            <Pane styleName="pane">
              <PaneHeader title="退会申請取り消しについて">
                <BreadCrumb items={breadCrumbItems} hasHome />
              </PaneHeader>
              <PaneBody>
                <div styleName="schedule_box">
                  <div styleName="schedule_text">{currentUser.currentUser.name}さんの退会予定日</div>
                  <div styleName="schedule_date">
                    <WithdrawalDateTime dateTime={effectiveAt} />
                  </div>
                  <div styleName="schedule_note">
                    ※<WithdrawalDateTime dateTime={serviceExpiresAt} />
                    までサービスをご利用いただけます
                  </div>
                </div>
                <div styleName="attention">
                  <LabelPrimary label="退会申請の取り消しについて" />
                  <div styleName="text">
                    ただいま退会申請を受け付けており、
                    <WithdrawalDateTime styleName="date_text" dateTime={effectiveAt} />
                    で退会処理が完了し、SHElikesの全サービスがご利用いただけなくなります。上記日程で退会せず受講を継続する場合は、退会申請を取り消すボタンを押してください。
                  </div>
                </div>

                <div styleName="submit_button">
                  <Button onClick={() => submit(withdrawal.withdrawalId)} id="withdrawal-cancel-submit-button">
                    退会申請を取り消す
                  </Button>
                </div>
                <SheModal open={open} onRequestClose={() => GlobalStatesV3.routing.push(V3Routes.home())}>
                  <WithdrawalCancelCompletePane onCompleteClick={() => GlobalStatesV3.routing.push(V3Routes.home())} />
                </SheModal>
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
